import { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { ShieldAlert } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../ui/card';
import { Switch } from '../ui/switch';
import { Label } from '../ui/label';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const LoginAlertSettingsCard = () => {
  const [enabled, setEnabled] = useState(null);

  useEffect(() => {
    axios.get(`${API}/system-settings`).then(res => setEnabled(res.data?.login_alert_enabled !== false)).catch(() => setEnabled(true));
  }, []);

  const toggle = async (value) => {
    setEnabled(value);
    try {
      await axios.put(`${API}/system-settings`, { login_alert_enabled: value });
      toast.success(value ? 'Yeni cihaz giriş bildirimi açıldı' : 'Yeni cihaz giriş bildirimi kapatıldı');
    } catch {
      setEnabled(!value);
      toast.error('Ayar kaydedilemedi');
    }
  };

  return (
    <Card className="border-slate-200" data-testid="login-alert-settings-card">
      <CardHeader>
        <CardTitle className="flex items-center gap-2"><ShieldAlert className="h-5 w-5" />Giriş Güvenliği</CardTitle>
        <CardDescription>Hesaba yeni bir cihaz veya tarayıcıdan giriş yapıldığında kullanıcıya e-posta ile bilgi verin</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="flex items-center justify-between gap-4 p-4 bg-slate-50 rounded-lg">
          <div className="space-y-0.5">
            <Label className="text-base font-medium">Yeni Cihaz Giriş Bildirimi</Label>
            <p className="text-sm text-slate-500">Tüm kullanıcılara (admin, uzman, firma yetkilisi) tarih, IP ve cihaz bilgisiyle e-posta gönderilir.</p>
          </div>
          <Switch checked={!!enabled} disabled={enabled === null} onCheckedChange={toggle} data-testid="login-alert-switch" />
        </div>
      </CardContent>
    </Card>
  );
};
